export default "__VITE_ASSET__$w5xc7Ou__"